module.exports = __webpack_public_path__ + "img/TGI.5450be06.png";